import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiService } from '../services/api';
import tokenManager from '../utils/tokenManager';
import { saveUserToLocalStorage } from '../utils/userUtils';

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(() => Boolean(localStorage.getItem('token')));

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      if (token === 'demo-token') {
        saveUserToLocalStorage({
          username: 'demo_user',
          role: 'admin',
          is_superuser: true,
        }, { token });
        setIsAuthenticated(true);
        return;
      }

      // Для JWT токенов проверяем, нужно ли обновить
      if (tokenManager.shouldRefreshToken()) {
        try {
          await tokenManager.refreshToken();
        } catch (error) {
          setIsAuthenticated(false);
          return;
        }
      }

      // Проверяем JWT токен
      const response = await apiService.getCurrentUser();
      if (response.data) {
        saveUserToLocalStorage(response.data, { token });
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
    }
  };

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
